import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePublication, { usePublicationForm } from '@hooks/usePublication'

import timeZones from '@functions/timeZones'

import Deadline from './Deadline'

const ManagePublicationDeadlinesModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updatePublication } = callbacks

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { publication } = modalPayload

  const {
    callbacks: { updatePublication: updateFn },
    updating,
  } = usePublication(publication)

  const publicationForm = usePublicationForm(publication)

  const {
    entityState,
    entityState: {
      options,
      time_zone,
    },
    handlers,
  } = publicationForm

  const {
    deadline_version,
    enable_time_zones,
  } = options || {}

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Edition Deadlines Updated',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Edition" titleSecondLine="Deadlines" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="Version">
            <select name="options.deadline_version" value={deadline_version} {...handlers}>
              <option value="">Please Select...</option>
              <option value="V1">Legacy</option>
              <option value="V2">Edition Deadlines</option>
            </select>
          </Form.Field>

          <Form.Field label="Timezones" marginTop="large">
            <select data-value-type="boolean" name="options.enable_time_zones" value={enable_time_zones} {...handlers}>
              <option value="">Please Select...</option>
              <option value="false">Disabled</option>
              <option value="true">Enabled</option>
            </select>
          </Form.Field>

          {enable_time_zones && (
            <Form.Field label="Region" marginTop="large">
              <select name="time_zone" value={time_zone} {...handlers}>
                <option value="">Please Select...</option>
                {timeZones.map(timezone => (
                  <option key={timezone.key} value={timezone.value}>
                    {timezone.title}
                  </option>
                ))}
              </select>
            </Form.Field>
          )}

          <Deadline publicationForm={publicationForm} type="booking" />

          <Deadline publicationForm={publicationForm} type="artwork" />

          <Deadline publicationForm={publicationForm} type="editorial" />

          <Deadline publicationForm={publicationForm} type="ofi" />
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updatePublication(updatePublicationPayload)}
          size="large"
        >
          Save Edition Deadlines
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

ManagePublicationDeadlinesModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

ManagePublicationDeadlinesModal.defaultProps = {
  modalKey: 'ManagePublicationDeadlinesModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <ManagePublicationDeadlinesModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
